module.exports = __webpack_public_path__ + "img/cup.bf69124d.png";